import React from 'react';
import { useLocation } from 'react-router-dom';
import { queryString } from '../../domain/share/services/queryString';

export const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => queryString(search), [search]);
};
